<template>
  <div>
    <icon-view
      gradient
      :icon="mainIcon"
      icon-background="#FF7058"
      icon-color="#fff"
      :title="mainTitle"
    />
    <div class="ml-0 ml-md-3 ml-sm-0">
      <div class="row mt-3">
        <div class="col-6">
          <div class="color-secondary-6 font-14">Conteo:</div>
          <div class="color-black font-weight-bold font-25">
            {{ serviceTotal }}
          </div>
        </div>
        <div class="col-6">
          <div class="color-secondary-6 font-14">Monto:</div>
          <div class="color-black font-weight-bold font-25">
            {{ amountTotal }}
          </div>
        </div>
      </div>
      <div
        v-if="details.length > 0"
        class="d-flex flex-column bg-light-gray rounded p-3 mt-3"
      >
        <div
          v-for="(item, index) in details"
          :key="`service-type-details_${index}`"
          class="d-flex"
        >
          <div class="flex-grow-1 color-gray-6 font-14 mb-3">
            {{ item.label }}
          </div>
          <span v-if="showDetail(item)" class="color-black font-14">
            {{ item.amount }} / {{ item.value | price }}
          </span>
          <span v-if="!showDetail(item)" class="color-black font-14">
            {{ item.value | price }}
          </span>
        </div>
      </div>
      <div
        v-if="enableToggle && !collapsed"
        class="collapse-container d-flex justify-content-center align-items-center cursor-pointer"
        @click="$emit('on-toggle', collapsed)"
      >
        <em class="text-white fa fa-chevron-down mr-2" />
        <span class="text-white">VER HISTORIAL</span>
      </div>
    </div>
  </div>
</template>

<script>
import billingServiceTypesDetail from '@/utils/constants/billingServiceTypesDetail.js';
import IconView from '../IconView';
export default {
  name: 'ServiceTypeView',
  components: {
    IconView,
  },
  props: {
    mainIcon: {
      type: String,
      default: () => '',
    },
    mainTitle: {
      type: String,
      default: () => '',
    },
    serviceTotal: {
      type: String,
      default: () => '',
    },
    amountTotal: {
      type: String,
      default: () => '',
    },
    details: {
      type: Array,
      default: () => [],
    },
    enableToggle: {
      type: Boolean,
      default: () => false,
    },
    collapsed: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    showDetail(item) {
      return item.type == billingServiceTypesDetail.Detail;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.collapse-container {
  background: map-get($colors, 'orange');
  padding: 3px;
  border-radius: 0px 0px 5px 5px;
  width: 40%;
  em {
    font-size: 12px;
  }
  span {
    font-size: 11px;
  }
}

@media only screen and (max-width: 768px) {
  .collapse-container {
    width: 100%;
  }
}
</style>
